export default __webpack_public_path__ + "static/media/comercializadora.4f514392.jpeg";